// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"31":"fe77e7bb3367b6b0","367":"62bc1460310f1e73","412":"97a6cf761c08c21c","543":"0cd6ce6b09f9261a","667":"52f9b57f952cd426","755":"2b0f22c61c3f468b","775":"01c54f40944540ce"}[chunkId] + ".js";
};